import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromWholesale from './wholesale.reducer';

export const selectWholesaleState = createFeatureSelector<fromWholesale.WholesaleState>(
    fromWholesale.productFeatureKey
);

export const selectProfile = createSelector(selectWholesaleState, (state) => state.profile);
